import React, { Component } from 'react';
import Radium from 'radium';
import PropTypes from 'prop-types';
import {
  Loader, Input, Button, Label,
} from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import bind from 'bind-decorator';
import {
  INVALID_ENROLLMENT_CODE,
  ALREADY_ENROLLED,
  EXPIRED_ENROLLMENT_CODE,
} from '../../constants';
import { hickoryGreen } from '../../styles/palette';

const s = {
  container: {
    display: 'flex',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#f5f5f5',
  },
  enrollmentCardTitle: {
    fontSize: '2.2em',
    fontWeight: 'bold',
    textAlign: 'center',
    marginTop: '20px',
  },
  enrollmentCard: {
    backgroundColor: 'white',
    width: '36rem',
  },
  cardContents: {
    margin: '20px',
    display: 'flex',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
  },
  button: {
    width: '100%',
    height: '4em',
    backgroundColor: hickoryGreen,
    color: 'white',
  },
  loginLink: {
    margin: '20px',
  },
  input: {
    width: '100%',
    marginBottom: '20px',
    height: '4em',
  },
  inputBox: {
    width: '100%',
  },
  labelBox: {
    width: '100%',
    fontWeight: 'bold',
    marginTop: '20px',
  },
};

class EnrollmentContainer extends Component {
  static propTypes = {
    match: PropTypes.object,
  };

  constructor(props) {
    super(props);

    this.state = {
      verification_code: props.match.params.verification_code,
      loading: true,
    };
  }

  @bind
  async componentDidMount() {
    const response = await fetch(`/api/v2/enroll/${this.state.verification_code}`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    });

    if (response.status === 200) {
      const status = await response.json();

      this.setState({ unexpected_error: false, code: status.code });
    } else {
      this.setState({ unexpected_error: true });
    }
    this.setState({ loading: false });
  }

  @bind
  async doEnroll() {
    let error = false;
    let errorMessage = '';

    const { password } = this.state;
    const verifyPassword = this.state.verify_password;
    if (password !== verifyPassword) {
      error = true;
      errorMessage = 'The password and password confirmation do not match.';
    } else if (password === null || password.length < 8) {
      error = true;
      errorMessage = 'The password must be at least 8 characters in length.';
    }
    if (error) {
      this.setState({ error, error_message: errorMessage });
      return;
    }

    const response = await fetch('/api/v2/enroll/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        verification_code: this.state.verification_code,
        password,
      }),
    });

    if (response.status === 200) {
      this.setState({ success: true });
    } else {
      this.setState({ unexpected_error: true });
    }
  }

  render() {
    if (this.state.loading) {
      return (
        <div style={s.container}>
          <Loader active inline="centered" />
        </div>
      );
    }

    if (this.state.success) {
      return (
        <div style={s.container}>
          <div style={s.enrollmentCard}>
            <div style={s.enrollmentCardTitle}>Congratulations!</div>
            <div style={s.cardContents}>
              Congrats - you&apos;re successfully registered! Use the &quot;login&quot; link below
              to log into Hickory and start learning in a whole new way.
              <Link style={s.loginLink} to="/app/v2/login">
                Login
              </Link>
            </div>
          </div>
        </div>
      );
    }

    let errorMessage = null;
    if (this.state.unexpected_error) {
      errorMessage = "We're sorry, but we're unable to process that invite at this time. Please try again in a ";
      errorMessage += 'couple of minutes.';
    } else if (this.state.code === INVALID_ENROLLMENT_CODE) {
      errorMessage = 'There was a problem with your invite. Please ask your manager to re-send your invite.';
    } else if (this.state.code === EXPIRED_ENROLLMENT_CODE) {
      errorMessage = 'The invite link you clicked has expired. Invites are only good for a few days from receipt. ';
      errorMessage += 'Please contact your manager to request that a new invite be sent.';
    } else if (this.state.code === ALREADY_ENROLLED) {
      errorMessage = "You've previously enrolled in Hickory - no need to click the invite link again. Simply click ";
      errorMessage += '"login" below to log into Hickory.';
    }

    if (errorMessage) {
      return (
        <div style={s.container}>
          <div style={s.enrollmentCard}>
            <div style={s.enrollmentCardTitle}>There was a problem...</div>
            <div style={s.cardContents}>
              {errorMessage}
              {this.state.code === ALREADY_ENROLLED ? (
                <Link style={s.loginLink} to="/app/v2/login">
                  Login
                </Link>
              ) : null}
            </div>
          </div>
        </div>
      );
    }
    return (
      <div style={s.container}>
        <div style={s.enrollmentCard}>
          <div style={s.enrollmentCardTitle}>Welcome to Hickory</div>
          <div style={s.cardContents}>
            Welcome to Hickory, we&apos;re glad to have you here. All that remains is for you to
            choose a password.
            {this.state.error ? (
              <Label color="red" style={s.labelBox}>
                {this.state.error_message}
              </Label>
            ) : null}
            <div style={s.labelBox}>Password</div>
            <div style={s.inputBox}>
              <Input
                type="password"
                style={s.input}
                onChange={(e, { value }) => this.setState({ password: value })}
              />
            </div>
            <div style={s.labelBox}>Confirm Password</div>
            <div style={s.inputBox}>
              <Input
                type="password"
                style={s.input}
                onChange={(e, { value }) => this.setState({ verify_password: value })}
              />
            </div>
            <Button style={s.button} onClick={this.doEnroll}>
              Enroll
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

export default Radium(EnrollmentContainer);
